import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=5bc3e15c&scoped=true"
var script = {}
import style0 from "./Candle.vue?vue&type=style&index=0&id=5bc3e15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3e15c",
  null
  
)

export default component.exports